<template>
  <v-form class="mt-5 mr-1 orange lighten-5 pa-4 rounded-lg" :disabled="updating" v-model="valid"
    @submit.prevent="update">
    <v-row dense>
      <v-col cols="6" lg="3">
        <v-text-field dense full-width hide-details label="Start of Election" prepend-inner-icon="mdi-clock-start"
          :rules="rules.required" filled type="time" v-model="start" hint="Time is in 24H format"></v-text-field>
      </v-col>
      <v-col cols="6" lg="3">
        <v-text-field dense full-width hide-details label="End of Election" prepend-inner-icon="mdi-clock-end"
          :rules="rules.required" filled type="time" v-model="end" hint="Time is in 24H format"></v-text-field>
      </v-col>
    </v-row>
    <div class="mt-3">
      <v-btn type="submit" class="mr-2">
        Update
      </v-btn>
      <v-btn text @click="cancel">
        Cancel
      </v-btn>
    </div>
  </v-form>
</template>

<script>
import { required } from "../../../tools/rules";
export default {
  props: ['election', 'start', 'end'],
  data: () => ({
    valid: false,
    updating: false,
    rules: { required },
  }),

  methods: {
    cancel() {
      this.$emit('cancelled');
    },
    update() {
      this.updating = true;

      this.$axios({
        url: `/election/time/${this.election}`,
        method: "PUT",
        params: {
          start: this.start,
          end: this.end,
        },
      })
        .then(() => {
          this.$emit('updated');
          this.$bus.$emit("snackbar", {
            type: "info",
            message: "Election time updated",
          });
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not update election time",
          });
        })
        .finally(() => {
          this.$emit('cancelled');
          this.updating = false;
        });
    },
  }
};
</script>
